"use client";

import { Button, Container } from "@/components/ui/tailwind-components";
import type { HeroProps } from "@/lib/sections/hero.types";

export function HeroSection(props: HeroProps) {
  // 🚫 This component does NOT render wedding poster heroes
  if (props.layout === "wedding-poster") return null;

  const {
    title,
    subtitle,
    dateLine,
    backgroundImageUrl,
    cta,
    layout = "centered",
  } = props;

  const backgroundClasses =
    layout === "image" && backgroundImageUrl
      ? "bg-cover bg-center relative before:absolute before:inset-0 before:bg-black/50 before:z-10"
      : "bg-gradient-to-br from-gray-50 via-white to-blue-50";

  return (
    <div
      className={`relative min-h-screen flex items-center justify-center ${backgroundClasses}`}
      style={
        backgroundImageUrl
          ? { backgroundImage: `url(${backgroundImageUrl})` }
          : undefined
      }
    >
      <div className="relative z-20">
        <Container>
          <div className="text-center max-w-5xl mx-auto space-y-8">

            <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 leading-tight">
              {title}
            </h1>

            {subtitle && (
              <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                {subtitle}
              </p>
            )}

            {dateLine && (
              <p className="text-lg text-gray-500 font-medium">
                {dateLine}
              </p>
            )}

            {cta && (
              <div className="flex justify-center">
                <Button size="lg">
                  {cta.label}
                </Button>
              </div>
            )}

          </div>
        </Container>
      </div>
    </div>
  );
}
